export enum FishingCatchTier {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Premium = 'premium',
  Trophy = 'trophy',
}

const TIER_VARIANTS: Readonly<Record<FishingCatchTier, readonly number[]>> = {
  [FishingCatchTier.Small]: [0, 1, 2],
  [FishingCatchTier.Medium]: [3, 4, 5],
  [FishingCatchTier.Large]: [6, 7, 8],
  [FishingCatchTier.Premium]: [9, 10, 11],
  [FishingCatchTier.Trophy]: [12],
}

export function fishingCatchTier(amount: number): FishingCatchTier {
  if (amount > 100_000) return FishingCatchTier.Trophy
  if (amount >= 50_000) return FishingCatchTier.Premium
  if (amount >= 30_000) return FishingCatchTier.Large
  if (amount >= 10_000) return FishingCatchTier.Medium
  return FishingCatchTier.Small
}

function stableSeed(value: string): number {
  let hash = 2166136261
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

export function fishingCatchVariant(amount: number, eventId: string): number {
  const variants = TIER_VARIANTS[fishingCatchTier(amount)]
  return variants[stableSeed(eventId) % variants.length]
}
